import type { UserStaff } from '../types/user';

/** The roles that score a whole competition, as opposed to one squad's athletes. */
const WHOLE_ROUND_ROLES = ['admin', 'editor', 'judge'] as const;

/**
 * Whether this viewer scores the whole round here — an admin, an editor or a
 * judge of the competition, the circuit's and the venue's included, since the
 * profile payload already reports a role reached that way as a row of its own
 * (Staff.effective_for).
 *
 * The one other person who reaches a scoring page is a squad's **team manager**,
 * and they get there for their own athletes alone. So this is what decides
 * whether a scoring page asks for the whole entry list or only for their squads'
 * (`team: 'mine'`): everybody who is neither is narrowed, which for a stray
 * visitor means an empty table rather than somebody else's start list.
 */
export function scoresWholeRound(staff: UserStaff[] | undefined, slug: string | undefined): boolean {
  if (!slug) return false;

  const here = staff?.find((row) => row.gym_slug === slug);
  if (!here || here.status !== 'confirmed') return false;

  return here.staff_roles.some((role) => WHOLE_ROUND_ROLES.includes(role as never));
}
